import { render, staticRenderFns } from "./authAccount.vue?vue&type=template&id=b16a704c&scoped=true"
import script from "./authAccount.vue?vue&type=script&lang=js"
export * from "./authAccount.vue?vue&type=script&lang=js"
import style0 from "./authAccount.vue?vue&type=style&index=0&id=b16a704c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16a704c",
  null
  
)

export default component.exports